module.exports = __webpack_public_path__ + "img/9791185994314.334b2530.jpg";